import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Page } from 'src/app/models/page.model';
import { ApiService } from 'src/app/services/api.service';
import { CommonService } from 'src/app/services/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-help-premium-config',
  templateUrl: './help-premium-config.page.html',
  styleUrls: ['./help-premium-config.page.scss'],
})
export class HelpPremiumConfigPage implements OnInit {
  @ViewChild('activeFrameinputHelpFile') InputFrameVariableHelp: ElementRef;
  @ViewChild('activeFrameinputPremiumFile') InputFrameVariablePremium: ElementRef;
  @ViewChild('activeFrameinputHeaderFile') InputeFrameVariableHeader: ElementRef;
  quickscanId: string;
  help: any = {};
  premium: any = {};
  showPage: boolean = false;
  preventClick: boolean = true;
  toggleSubscription: Subscription;
  itemsSelected = []
  AllLocales = []
  category:any;

  controlStatus: any = {
    EmailAddress: false,
    PhoneNumber: false
  };


  locale: any;
  tempLocale: any;

  helpForm: FormGroup;
  premiumForm: FormGroup;
  submitted = false;
  premiumImageList: Array<any> = [];
  helpImageList: Array<any> = [];
  headerImageList: Array<any> = [];
  selectedImage: Array<any> = [];
  helpImageArray: Array<any> = [];
  premiumImageArray: Array<any> = [];
  headerImageArray: Array<any> = [];

 


  constructor(private formBuilder: FormBuilder, private location: Location, private _apiService: ApiService, public _commonService: CommonService, private route: ActivatedRoute, private router: Router) 
  {}

  ngOnInit() {
    this.helpForm = this.formBuilder.group({
      Text: ['', Validators.required],
      EmailAddress: ['', [Validators.required, Validators.email]],
      //PhoneNumber: ['', [Validators.required, Validators.pattern(this._commonService.phonePattern)]],
    });  
    this.premiumForm = this.formBuilder.group({
      Text: ['', Validators.required],
      EmailAddress: ['', [Validators.required, Validators.email]],
      PhoneNumber: ['', [Validators.required, Validators.pattern(this._commonService.phonePattern)]],
      // Image: ['', Validators.required],
      // ImageName: [''],
    });
  }

  ionViewWillEnter() {

  }
  ionViewDidEnter(){
    this.category = 'help';
    this.locale = Number((localStorage.locale && localStorage.locale != '') ? localStorage.locale : 1043);
    this.tempLocale = this.locale;
    if(localStorage.authenticationKey){
      forkJoin([
        this.getHelpDetail(),
      this.getPremiumDetail()
      ])

     
    }
  }



  async getHelpDetail(){
    this._commonService.presentLoading();
     try {
       let res = await this._apiService.getHelpDetail();
        this.help = res.body;

        forkJoin([
         this.getHeaderImage(),
          await this.getHelpImage()
        ])

       this._commonService.log(this.help, this._commonService.LOG);
        if(this.help){
          this._commonService.helpDetail = this.help;
        }
       this.helpForm.patchValue({
          Text: this.help.HelpText,
          EmailAddress: this.help.Email,
          //PhoneNumber: this.help.Phone,
        });
      this.helpForm.updateValueAndValidity();
      this.showPage = true;
      this._commonService.dismiss();
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR)
    }
  }


  async getHelpImage(){
     try {
       let res = await this._apiService.getHelpImage();
       this.helpImageList = [];
        let image = res.body;
          image.forEach((pic) => {
            let ext = pic.Name.split('.').pop();
            let i = "data:image/" + ext + ";base64," + pic.Data;
            let value = {
              Name: pic.Name,
              Data: pic.Data,
              image : i,
              select: false,
              uploaded: false
          } 
            this.helpImageList.push(value);
          })
      this.showPage = true;
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR)
    }
  }

  async getHeaderImage(){
     try {
       let res = await this._apiService.getHeaderImage();
       this.headerImageList = [];
        let image = res.body;
          image.forEach((pic) => {
            let ext = pic.Name.split('.').pop();
            let i = "data:image/" + ext + ";base64," + pic.Data;
            let value = {
              Name: pic.Name,
              Data: pic.Data,
              image : i,
              select: false,
              uploaded: false
          } 
            this.headerImageList.push(value);
          })
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR)
    }
  }


  async getCurrentImage() {
    try {
      let res = await this._apiService.getCurrentHelpImage();
      if(res.body){
        let helpImage = [];
        let image = res.body;
          let ext = image.Name.split('.').pop();
          let im = "data:image/" + ext + ";base64," + image.Data;
          
          let value = {
            Name: image.Name,
            Data: image.Data,
            image: im,
          }
          helpImage.push(value);
          localStorage.setItem('currentImage', JSON.stringify(im));
          this._commonService.helpImage = helpImage[0].image;
      } else {
        localStorage.setItem('currentImage', "");
        this._commonService.helpImage = "";
      }
    
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR)
    }
  }

  async getCurrentHeaderImage() {
    try {
      let res = await this._apiService.getCurrentHeaderImage();
      if(res.body){
        let headerImage = [];
        let image = res.body;
          let ext = image.Name.split('.').pop();
          let im = "data:image/" + ext + ";base64," + image.Data;
          
          let value = {
            Name: image.Name,
            Data: image.Data,
            image: im,
          }
          headerImage.push(value);
          localStorage.setItem('currentHeaderImage', JSON.stringify(im));
          this._commonService.headerImage = headerImage[0].image;
      } else {
        localStorage.setItem('currentHeaderImage', "");
        this._commonService.headerImage = "";
      }
    
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR)
    }
  }


  async getPremiumDetail(){
     try {
       let res = await this._apiService.getPremiumDetail();
        this.premium = res.body;
        localStorage.premiumDetail = JSON.stringify(res.body)
        await this.getPremiumImage();
       this._commonService.log(this.premium, this._commonService.LOG);
 
       this.premiumForm.patchValue({
        Text: this.premium.PremiumText,
        EmailAddress: this.premium.Email,
        PhoneNumber: this.premium.Phone,
        });
      this.premiumForm.updateValueAndValidity();
      this.showPage = true;
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR)
    }
  }

  async getPremiumImage(){
    this._commonService.presentLoading();
     try {
       let res = await this._apiService.getPremiumImage();
      // this.premiumImageList = [];
        let image = res.body;
        let arr = [];
          image.forEach((pic) => {
            let ext = pic.Name.split('.').pop();
            let i = "data:image/" + ext + ";base64," + pic.Data;
            let value = {
              Name: pic.Name,
              Data: pic.Data,
              image : i,
              select: false,
              uploaded: false
          }
          arr.push(value);
          })
          this.premiumImageList = arr;
          localStorage.premiumImageName = JSON.stringify(arr[0].image)
      this.showPage = true;
      this._commonService.dismiss();
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR)
    }
  }

  async getLocales() {
    try {
      if (localStorage.domainLocales) {
        this.AllLocales = JSON.parse(localStorage.domainLocales);
        for (let i = 0; i < this.AllLocales.length; i++) {
          if (this.AllLocales[i].LocaleIconUrl == 'flag-icon-nl') {
            this.AllLocales[i].Icon = 'assets/flags/1x1/nl.svg'
          }
          if (this.AllLocales[i].LocaleIconUrl == 'flag-icon-gb') {
            this.AllLocales[i].Icon = 'assets/flags/1x1/gb.svg'
          }
        }
      } else {
        let localeData = await this._apiService.getDomainLocales('', 1, 0);
        this.AllLocales = localeData.body;
        for (let i = 0; i < this.AllLocales.length; i++) {
          if (this.AllLocales[i].LocaleIconUrl == 'flag-icon-nl') {
            this.AllLocales[i].Icon = 'assets/flags/1x1/nl.svg'
          }
          if (this.AllLocales[i].LocaleIconUrl == 'flag-icon-gb') {
            this.AllLocales[i].Icon = 'assets/flags/1x1/gb.svg'
          }
        }
        localStorage.domainLocales = JSON.stringify(localeData.body);
      }
    } catch (error) {
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  get f() { return this.helpForm.controls; }
  get fPremium() { return this.premiumForm.controls; }

  async onSubmit() {
    this.submitted = true;

    if (this.helpForm.invalid) {
      this._commonService.scrollToError();
      return;
    }
    if (this.premiumForm.invalid) {
      this._commonService.scrollToError();
      return;
    }
 
    this._commonService.presentLoading();
    try {
      let helpData = { 
        HelpText: this.helpForm.value.Text,
        Email: this.helpForm.value.EmailAddress,
        //Phone: this.helpForm.value.PhoneNumber,
      }
      let premiumData = { 
        PremiumText: this.premiumForm.value.Text,
        Email: this.premiumForm.value.EmailAddress,
        Phone: this.premiumForm.value.PhoneNumber,
      }
      let imageData = [];
      this.helpImageList.forEach( row => {
        if(row.uploaded) {
          let value = {
            Name: row.Name,
            Data: row.Data,
        }     
          imageData.push(value);
        }
      });
      let premiumImageData = [];
      this.premiumImageList.forEach( row => {
        if(row.uploaded) {
          let value = {
            Name: row.Name,
            Data: row.Data,
        }     
        premiumImageData.push(value);
        }
      });

      let headerImageData = [];
      this.headerImageList.forEach( row => {
        if(row.uploaded) {
          let value = {
            Name: row.Name,
            Data: row.Data,
        }     
        headerImageData.push(value);
        }
      });
      forkJoin([
      this._apiService.putHelp(helpData),
      this._apiService.putPremium(premiumData),
      this._apiService.putHelpImage(imageData),
      await this._apiService.putHeaderImage(headerImageData),
      await this._apiService.putPremiumImage(premiumImageData)
      ])

      

      this.helpImageArray = [];
      this.headerImageArray = [];

      forkJoin([
        this.getHelpDetail(),
        this.getPremiumDetail(),    
        this.getCurrentImage(),
        await this.getCurrentHeaderImage() 
        ])

     
     
      this._commonService.showToast(this._commonService.getLocalTranslation('label-recordSaved'));
      this._commonService.log(helpData, this._commonService.LOG);
      this.submitted = false;
     // this.getQuickScanDetails();
    } catch (error) {
      
      forkJoin([
        this.getHelpImage(),
      this.getHeaderImage(),
      this.getPremiumImage()
        ])
      
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }


  ionViewDidLeave() {
  this.helpImageList = [];
  this.premiumImageList = [];
  this.headerImageList = []
  }

  goBack() {
    this.location.back();
  }

  onSelectFile(event: any, type) {
    if (event.target.files && event.target.files[0]) {
      var filesAmount = event.target.files.length;
      for (var i = 0; i < filesAmount; i++) {
        var reader = new FileReader();
        let imageName = event.target.files[i].name.replace(/[~!@#$%^&*()_|+\-=?; :'",<>\{\}\[\]\\\/]/gi, '').split('.');
        let time = new Date().getTime();
        reader.onload = (event: any) => {
          let value = {
            Name: imageName[0] + time + "." + imageName[imageName.length - 1],
            Data: event.target.result.split(',').pop(),
            image: event.target.result,
            select: false,
            uploaded: true
        } // called once readAsDataURL is completed
        if(type == 'help'){
          this.helpImageList.push(value);
        } else if ( type == 'premium') {
          this.premiumImageList = [];
          this.premiumImageList.push(value);
        }else if (type == 'header'){
          this.headerImageList.push(value);
        }
        
        }
        reader.readAsDataURL(event.target.files[i]); // read file as data url
      }
    }
    if(this.InputFrameVariablePremium){
      this.InputFrameVariablePremium.nativeElement.value = '';
    }
    if(this.InputFrameVariableHelp){
      this.InputFrameVariableHelp.nativeElement.value = '';
    }
    if(this.InputeFrameVariableHeader){
      this.InputeFrameVariableHeader.nativeElement.value = '';
    }
  }



  async deleteHelpImage() {
    this._commonService.presentAlertConfirm()
      .then(async (res) => {
        try {
          this._commonService.presentLoading();
          let uploadedImage = [];
          let dbImage = [];
          if (this.helpImageList) {
            this.helpImageList.filter(element => {
              if (element.uploaded == true && element.select == true) {
                uploadedImage.push(element);
              } else if(element.uploaded == false && element.select == true) {
                dbImage.push(element);
              }
            });
          }
          this.InputFrameVariableHelp.nativeElement.value = '';
          this.helpImageArray = [];
          if (uploadedImage.length != 0 && dbImage.length == 0) {
            this.helpImageList = this.helpImageList.filter(e => e.select != true);
          }
          if (dbImage.length != 0) {
            let nameArray = [];
            nameArray = dbImage.map(x => x.Name);
            this.helpImageList = this.helpImageList.filter(e => e.select != true);
            
               await this._apiService.deleteHelpImage(nameArray.join()),  
              await this.getCurrentImage() 
              

           
            // this.getHelpImage();
          }
          this._commonService.log(res, this._commonService.LOG);
          this._commonService.dismiss();
        }
        catch (error) {
          this._commonService.dismiss();
          this._commonService.log(error, this._commonService.ERROR);
        }
      })
      .catch((err) => {
        this._commonService.log(err, this._commonService.LOG);
      })
  }


  async deletePremiumImage() {
    this._commonService.presentAlertConfirm()
      .then(async (res) => {
        try {
          this._commonService.presentLoading();
          let uploadedImage = [];
          let dbImage = [];
        
          if (this.premiumImageList) {
            this.premiumImageList.filter(element => {
              if (element.uploaded == true) {
                uploadedImage.push(element);
              } else if(element.uploaded == false) {
                dbImage.push(element);
              }
            });
          }
          this.InputFrameVariablePremium.nativeElement.value = '';
          this.helpImageArray = [];
          if (uploadedImage.length != 0) {
            this._commonService.dismiss();
            this.premiumImageList = [];
          }
          if (dbImage.length != 0) {
            let nameArray = [];
            nameArray = dbImage.map(x => x.Name);
            await this._apiService.deletePremiumImage(nameArray.join());
            this._commonService.dismiss();
            this.premiumImageList = [];
          }
        }
        catch (error) {
          this._commonService.dismiss();
          this._commonService.log(error, this._commonService.ERROR);
        }
      })
      .catch((err) => {
        this._commonService.log(err, this._commonService.LOG);
      })
  }

  deleteHeaderImage(){
    this._commonService.presentAlertConfirm()
    .then(async (res) => {
      try {
        this._commonService.presentLoading();
        let uploadedImage = [];
        let dbImage = [];
        if (this.headerImageList) {
          this.headerImageList.filter(element => {
            if (element.uploaded == true && element.select == true) {
              uploadedImage.push(element);
            } else if(element.uploaded == false && element.select == true) {
              dbImage.push(element);
            }
          });
        }
        this.InputeFrameVariableHeader.nativeElement.value = '';
        this.headerImageArray = [];
        if (uploadedImage.length != 0 && dbImage.length == 0) {
          this.headerImageList = this.headerImageList.filter(e => e.select != true);
        }
        if (dbImage.length != 0) {
          let nameArray = [];
          nameArray = dbImage.map(x => x.Name);
          this.headerImageList = this.headerImageList.filter(e => e.select != true);
         
            await this._apiService.deleteHeaderImage(nameArray.join()),   
            await this.getCurrentHeaderImage()
        
        }
        this._commonService.log(res, this._commonService.LOG);
        this._commonService.dismiss();
      }
      catch (error) {
        this._commonService.dismiss();
        this._commonService.log(error, this._commonService.ERROR);
      }
    })
    .catch((err) => {
      this._commonService.log(err, this._commonService.LOG);
    })
  }



  onBlurMethod(controlName){
    if(controlName == 'EmailAddress'){
      this.controlStatus.EmailAddress = true
    }
    if(controlName == 'PhoneNumber'){
     this.controlStatus.PhoneNumber = true
   }
   }
 
   onFocusMethod(controlName){
     if(controlName == 'EmailAddress'){
       this.controlStatus.EmailAddress = false
     }
     if(controlName == 'PhoneNumber'){
       this.controlStatus.PhoneNumber = false
     }
   }

 

  selectHelpImage(value){
    let selected = [];
    if(this.helpImageList) {
      this.helpImageList.filter(element =>  {
        if(element.Name == value.Name) {
          if(element.select == true){
            element.select = false
          } else {
            element.select = true;
          }
        }
      });
    }
    this.helpImageArray =  this.helpImageList.filter(element =>  element.select == true);
  }

  selectHeaderImage(value){
    let selected = [];
    if(this.headerImageList) {
      this.headerImageList.filter(element =>  {
        if(element.Name == value.Name) {
          if(element.select == true){
            element.select = false
          } else {
            element.select = true;
          }
        }
      });
    }
    this.headerImageArray =  this.headerImageList.filter(element =>  element.select == true);
  }

  onActionChange(obj) {

    switch (obj.Action) {
      case "save":
          this.onSubmit();
          break;
      case "backToList":
          this.goBack();
          break;
      case "backToMain":
          this.router.navigate(['maintenance'], { replaceUrl: true })
          break;
      case "back":
          this.goBack();
          break;
      }
      
  }

}
